import { gql } from "@apollo/client";

export const GET_GENERATE_NEW_PROTOCOL_DATA = gql`
    query GetGenerateNewProtocolData($assemblyid: uuid!) {
        file_v_generate_new_protocol(where: { assemblyid: { _eq: $assemblyid } }, limit: 1) {
            assembly_last_updated
            file_last_inserted
            generate_new_protocol
            fileid
        }
    }
`;
